/* eslint-disable camelcase */
import React, {
    useEffect, useCallback, useContext, useState
} from 'react';
import generateGuid from 'uuid/v4';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { WizardPage, WizardPageTemplate, wizardProps } from 'gw-portals-wizard-react';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withRouter, useHistory } from 'react-router-dom';
import { messages as commonMessages } from 'gw-platform-translations';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { ModalNextProvider } from '@jutro/components';
import SasriaBank_EXT from 'gw-capability-fnol-common-react/models/SasriaBank_EXT';
import CustomizedUploadComponent from 'gw-capability-fnol-common-react/components/CustomizedDocumentUploadComponent/CustomizedUploadComponent';
import { useValidation } from 'gw-portals-validation-react';
import { claimsMessages } from 'gw-capability-claim-react';
import SasriaExpressClaim from 'gw-capability-fnol-common-react/models/SasriaExpressClaim';
import { _ITEM_PATH_ } from '@jutro/uimetadata';
import metadata from './SasriaAddBank.metadata.json5';
import styles from './SasriaAddBank.module.scss';
import messages from './SasriaAddBank.messages';
// import DocumentsComponent from '../../gw-capability-document-react/components/DocumentsComponent/DocumentsComponent';
import AddPaymentPopup from '../AddPaymentPopup/AddPaymentPopup';


function SasriaAddBank(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        history: {
            location: { state = {} }
        },

        authHeader
    } = props;

    const history = useHistory();
    const viewModelService = useContext(ViewModelServiceContext);
    const { FNOLService } = useDependencies('FNOLService');

    const bankViewModel = viewModelService.create(
        _.get(claimVM.value, 'agentInsuredBankArray_EXT') || new SasriaBank_EXT(),
        'cc',
        'edge.capabilities.claim.fnol.dto.AgentInsuredBankDTO_EXT',
    );
    const [bankVM] = useState(bankViewModel);
    const [insuredBankArray, setInsuredBankArray] = useState([]);
    const [agentBankArray, setAgentBankArray] = useState([]);
    const [isReimbursementSelected, setIsReimbursementSelected] = useState('Yes');
    const [selectAddAgentButtonClicked, setSelectAddAgentButtonClicked] = useState(false);
    const [addInsuredBankButtonClicked, setaddInsuredBankButtonClicked] = useState(false);
    const [bankNamesArray, setBankNamesArray] = useState([]);
    const [selectedBankName, setSelectedBankName] = useState('');
    const [selectedAccountType, setSelectedAccountType] = useState('current_EXT');
    const [isLoading, setIsLoading] = useState(false);
    const [totalBankArray, setTotalBankArray] = useState([]);
    const [agentBankList, setAgentBankList] = useState([]);
    const [agentBankDropdownList, setAgentBankDropdownList] = useState([]);
    const [existingInsuredBankArray, setExistingInsuredBankArray] = useState([]);
    const [insuredBankDropdownList, setInsuredBankDropdownList] = useState([]);
    const [selectedAgentBankAccNo, setSelectedAgentBankAccNo] = useState('');
    const [selectedInsuredBankAccNo, setSelectedInsuredBankAccNo] = useState('');
    const [existingInsuredBank, setExistingInsuredBank] = useState('New');
    const [individualPaymentArray, setIndividualPaymentArray] = useState([]);
    const [editPayment, setEditPayment] = useState(false);
    const { onValidate, isComponentValid, registerComponentValidation } = useValidation(
        'SasriaAddBank'
    );
    const [paymentIconClicked, setPaymentIconClicked] = useState(false);

    const encryptAccntNum = useCallback(
        (accNum) => {
            if (_.isUndefined(accNum) || _.isEmpty(accNum)) {
                return '';
            }

            return accNum.length <= 4 ? ((accNum.substring(0, 3)).concat('***')) : ((accNum.substring(0, 4)).concat('*****'));
        },
        [],
    );

    const getCodefilter = useCallback((retrievedList) => {
        return retrievedList.map((key) => {
            return {
                code: key,
                name: key
            };
        });
    }, []);

    const displayBankNames = useCallback(
        () => {
            if (bankNamesArray && bankNamesArray.length >= 1) {
                return bankNamesArray;
            }
            return FNOLService.populateSariaBankNames_EXT(authHeader)
                .then((bankNames) => {
                    const bankNamesList = getCodefilter(bankNames);
                    setBankNamesArray(bankNamesList);
                });
        },
        [FNOLService, authHeader, bankNamesArray, getCodefilter],
    );

    const handleAccountType = useCallback(
        (accountType) => {
            _.set(bankVM.value, 'accountType', accountType);
            setSelectedAccountType(accountType);
            updateWizardData(claimVM);
        },
        [bankVM, claimVM, updateWizardData],
    );

    const accountMap = {
        savings: 'Savings Account',
        other: 'Other Account',
        current_EXT: 'Current Account',
        cheque_EXT: 'Cheque Account',
        transmission_EXT: 'Transmission Account',
        bond_EXT: 'Bond Account'
    };

    const getbankDropdownCodefilter = useCallback((bankData) => {
        return bankData.map((key) => {
            return {
                code: `${key.bankName},${key.accountNumber},${_.get(accountMap, key.accountType)}`,
                name: `${key.bankName},${key.accountNumber},${_.get(accountMap, key.accountType)}`
            };
        });
    }, [accountMap]);


    const retrieveAgentBank = useCallback(
        () => {
            return FNOLService.populateExistingAgentBank_EXT(authHeader)
                .then((agentBankData) => {
                    setAgentBankList(agentBankData);
                    const agentDropdownArray = getbankDropdownCodefilter(agentBankData);
                    setAgentBankDropdownList(agentDropdownArray);
                });
        }, [FNOLService, authHeader, getbankDropdownCodefilter]
    );

    const retrieveExistingInsuredBank = useCallback(
        () => {
            return FNOLService.retrieveExistingInsuredBanks_EXT(claimVM.value, authHeader)
                .then((existingInsuredBankList) => {
                    setExistingInsuredBankArray(existingInsuredBankList);
                    const insuredBankDropdownArray = getbankDropdownCodefilter(existingInsuredBankList);
                    setInsuredBankDropdownList(insuredBankDropdownArray);
                });
        }, [FNOLService, authHeader, claimVM, getbankDropdownCodefilter]
    );

    const handleError = (title, message) => {
        return ModalNextProvider.showAlert({
            title: title,
            message: message,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    };


    const selectExistingAgentBank = useCallback(
        (value) => {
            if (!_.isUndefined(value)) {
                setSelectedAgentBankAccNo(value);
                const details = value.split(',');
                const bankAccNo = details[1];
                const selectedBank = _.find(agentBankList, { accountNumber: bankAccNo });
                const {
                    bankName, accountType, accountNumber, accountName, branchCode, publicId
                } = selectedBank;
                if (!_.isUndefined(selectedBank)) {
                    if (agentBankArray != null && !_.isEmpty(agentBankArray)) {
                        const duplicateBankCard = agentBankArray.filter((bnk) => bnk.accountType === accountType && bnk.accountNumber === accountNumber && bnk.bankName === bankName);
                        if (!_.isEmpty(duplicateBankCard)) {
                            setSelectedAgentBankAccNo('');
                            return handleError(
                                messages.duplicateAgentBankCardTitle,
                                messages.duplicateAgentBankCardMessage
                            );
                        }
                    }
                    setSelectedAccountType(accountType);
                    bankVM.bankName = bankName;
                    bankVM.accountType = accountType;
                    bankVM.accountNumber = accountNumber;
                    bankVM.accountName = accountName;
                    bankVM.branchCode = branchCode;
                    bankVM.publicId = publicId;
                }
            }
        },
        [agentBankArray, agentBankList, bankVM.accountName, bankVM.accountNumber, bankVM.accountType, bankVM.bankName, bankVM.branchCode, bankVM.publicId]
    );
    const selectExistingInsuredBank = useCallback(
        (value) => {
            if (!_.isUndefined(value)) {
                setSelectedInsuredBankAccNo(value);
                const details = value.split(',');
                const bankAccNo = details[1];
                const selectedBank = _.find(existingInsuredBankArray, { accountNumber: bankAccNo });
                if (!_.isUndefined(selectedBank)) {
                    const {
                        bankName, accountType, accountNumber, accountName, branchCode, publicId
                    } = selectedBank;
                    if (insuredBankArray != null && !_.isEmpty(insuredBankArray)) {
                        const dupliacteBankCard = insuredBankArray.filter((bnk) => bnk.accountType === accountType && bnk.accountNumber === accountNumber && bnk.bankName === bankName);
                        if (!_.isEmpty(dupliacteBankCard)) {
                            setSelectedInsuredBankAccNo('');
                            return handleError(
                                messages.duplicateInsuredBankCardTitle,
                                messages.duplicateInsuredBankCardMessage
                            );
                        }
                    }
                    setSelectedAccountType(accountType);
                    _.set(claimVM, 'accountNumber', accountNumber);
                    _.set(claimVM, 'accountName', accountName);
                    _.set(claimVM, 'branchCode', branchCode);
                    _.set(claimVM, 'bankName', bankName);
                    bankVM.bankName = bankName;
                    bankVM.accountType = accountType;
                    bankVM.accountNumber = accountNumber;
                    bankVM.accountName = accountName;
                    bankVM.branchCode = branchCode;
                    bankVM.publicId = publicId;
                    setSelectedBankName(bankName);
                }
            }
        },
        [bankVM.accountName, bankVM.accountNumber, bankVM.accountType, bankVM.bankName, bankVM.branchCode, bankVM.publicId, claimVM, existingInsuredBankArray, insuredBankArray]
    );

    const addBanksToArrayOnPrevious = useCallback(
        () => {
            const addedBankList = _.get(claimVM, 'agentInsuredBankArray_EXT.value');
            if (insuredBankArray.length === 0 && agentBankArray.length === 0 && !_.isUndefined(addedBankList) && addedBankList.length >= 1) {
                addedBankList.forEach((bnk) => {
                    if (bnk.insuredBank === true) {
                        insuredBankArray.push(bnk);
                        totalBankArray.push(bnk);
                    } else {
                        agentBankArray.push(bnk);
                        totalBankArray.push(bnk);
                    }
                });
            }
        },
        [agentBankArray, claimVM, insuredBankArray, totalBankArray],
    );

    const setValuesOnPrevious = useCallback(
        () => {
            const addedBankList = _.get(claimVM, 'agentInsuredBankArray_EXT.value', []);
            if (!_.isEmpty(addedBankList)) {
                const reimbursementselected = _.get(claimVM.value, 'reimbursementSelected_EXT');
                setIsReimbursementSelected(reimbursementselected === false ? 'No' : 'Yes');
            }
        },
        [claimVM],
    );

    useEffect(() => {
        setValuesOnPrevious();
        displayBankNames();
        updateWizardData(claimVM);
        retrieveAgentBank();
        retrieveExistingInsuredBank();
        addBanksToArrayOnPrevious();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const populateBankCode = useCallback(
        (bankname) => {
            FNOLService.populateSariaBranchCodeForBankName_EXT(bankname, authHeader)
                .then((branchcodePopulated) => {
                    if (!_.isEmpty(branchcodePopulated)) {
                        _.set(bankVM, 'branchCode', branchcodePopulated);
                        _.set(bankVM.value, 'branchCode', branchcodePopulated);
                        _.set(claimVM, 'branchCode', branchcodePopulated);
                    } else {
                        _.set(bankVM, 'branchCode', '');
                        _.set(bankVM.value, 'branchCode', '');
                    }
                    updateWizardData(claimVM);
                });
        },
        [FNOLService, authHeader, bankVM, claimVM, updateWizardData]
    );

    const populateBankNamesFromCC = useCallback(
        (bankName) => {
            _.set(bankVM.value, 'bankName', bankName);
            setSelectedBankName(bankName);
            populateBankCode(bankName);
        },
        [bankVM, populateBankCode],
    );


    const handleReimbursement = useCallback(
        (value) => {
            const reimbursementRadioButton = value === 'Yes';
            _.set(claimVM.value, 'reimbursementSelected_EXT', reimbursementRadioButton);
            setIsReimbursementSelected(value);
        },
        [claimVM.value],
    );

    const handleExistingInsuredBank = useCallback(
        (value) => {
            setExistingInsuredBank(value);
            bankVM.accountName = '';
            bankVM.accountNumber = '';
            bankVM.accountType = '';
            // bankVM.insuredAmount = '';
            bankVM.branchCode = '';
            bankVM.publicId = null;
            _.set(claimVM, 'accountNumber', '');
            _.set(claimVM, 'accountName', '');
            _.set(claimVM, 'branchCode', '');
            _.set(claimVM, 'agentAmount', '');
            // _.set(claimVM, 'insuredAmount', '');
            setSelectedBankName('');
            setSelectedAccountType('current_EXT');
            setSelectedInsuredBankAccNo('');
        },
        [bankVM.accountName, bankVM.accountNumber, bankVM.accountType, bankVM.branchCode, bankVM.publicId, claimVM],
    );

    const displayBankCategory = useCallback(
        (elem) => {
            if (elem.insuredBank === true) return 'Insured Bank Account';
            return 'Agent Bank Account';
        },
        [],
    );

    const displayPayeeType = useCallback(
        (elem) => {
            const { payeeType_EXT } = elem;
            if (payeeType_EXT === ('insured')) return 'Insured Bank Account';
            return 'Agent Bank Account';
        },
        [],
    );

    const displayIndividualInclVatAmt = useCallback(
        (elem) => {
            // eslint-disable-next-line camelcase
            const { lineItemData_EXT } = elem;
            let paymentAmt = 0.00;
            if (!_.isUndefined(lineItemData_EXT) && !_.isEmpty(lineItemData_EXT)) {
                lineItemData_EXT.forEach((lineItem) => {
                    const { vatInclAmount } = lineItem;
                    paymentAmt += Number(vatInclAmount);
                });
            }
            return `Total Incl VAT:  R${paymentAmt.toFixed(2)}`;
        },
        [],
    );

    const displayAmountInCard = useCallback(
        (elem) => {
            if (elem.insuredBank === true) return `Excess : R${elem.insuredAmount}`;
            return `Reimbursement : R${elem.agentAmount}`;
        },
        [],
    );


    const addInsuredBankButtonClickFunc = useCallback(
        () => {
            const accountNumber = _.get(bankVM, 'accountNumber').value;
            // const accountType = _.get(bankVM, 'accountType').value;
            const branchCode = _.get(bankVM, 'branchCode').value;
            const bankName = _.get(bankVM, 'bankName').value;
            const publicId = _.get(bankVM, 'publicId').value;
            const accountName = _.get(bankVM, 'accountName').value;
            const documentList = _.get(claimVM, 'documents.value', []);

            const insuredBank = true;
            const agentBank = false;
            let isExistingBankSelected = false;
            if (existingInsuredBank === 'Existing') {
                isExistingBankSelected = true;
            }
            // const insuredAmount = _.get(bankVM, 'insuredAmount').value;
            if (_.isUndefined(accountNumber) || _.isEmpty(accountNumber)) {
                return handleError(
                    messages.bankAccNumMandatoryTitle,
                    messages.bankAccNumMandatoryMessage
                );
            }

            const regRegex = new RegExp(/^(\d{1,13})?$/);
            if (!_.isUndefined(accountNumber) && !regRegex.test(accountNumber)) {
                return handleError(
                    messages.invalidBankTitle,
                    messages.invalidBankMessage
                );
            }

            if (_.isUndefined(selectedAccountType) || _.isEmpty(selectedAccountType)) {
                return handleError(
                    messages.bankAccTypeMandatoryTitle,
                    messages.bankAccTypeMandatoryMessage
                );
            }

            if (_.isUndefined(branchCode) || _.isEmpty(branchCode)) {
                return handleError(
                    messages.bankCodeNumMandatoryTitle,
                    messages.bankCodeNumMandatoryMessage
                );
            }

            // if (_.isUndefined(insuredAmount) || insuredAmount === '') {
            //     return handleError(
            //         messages.insuredamountFieldMandatoryTitle,
            //         messages.insuredamountFieldMandatoryMessage
            //     );
            // }

            // if (isNaN(insuredAmount) || parseFloat(insuredAmount) <= 0) {
            //     return handleError(
            //         messages.insuredamountFieldMandatoryTitle,
            //         messages.insuredamountFieldMandatoryMessage
            //     );
            // }

            if (_.isUndefined(bankName) || _.isEmpty(bankName)) {
                return handleError(
                    messages.bankNameMandatoryTitle,
                    messages.bankNameMandatoryMessage
                );
            }

            let bankDocuments = [];
            if (!_.isEmpty(documentList)) {
                bankDocuments = documentList.filter((doc) => doc.sasriaFormName_EXT === 'Account or Bank Confirmation' && doc.isDocumentTaggedToInsuredBankSTP_EXT === true);
            }
            if (_.isEmpty(bankDocuments)) {
                return handleError(
                    messages.bankDocumentMandatoryTitle,
                    messages.bankDocumentMandatoryMessage
                );
            }

            const checkIfExistingBank = existingInsuredBankArray.filter((bank) => (bank.bankName === bankName && bank.accountNumber === accountNumber && bank.accountType === selectedAccountType && bank.branchCode === branchCode));

            if (isExistingBankSelected !== true && checkIfExistingBank != null && !_.isEmpty(checkIfExistingBank)) {
                return handleError(
                    messages.checkIfExistingInsuredBankTitle,
                    messages.checkIfExistingInsuredBankMessage
                );
            }
            const bankValue = {
                accountNumber, accountType: selectedAccountType, branchCode, bankName, publicId, accountName, insuredBank, agentBank, isExistingBankSelected
            };

            insuredBankArray.push(bankValue);
            totalBankArray.push(bankValue);
            setTotalBankArray(totalBankArray);
            setInsuredBankArray(insuredBankArray);
            _.set(claimVM.value, 'agentInsuredBankArray_EXT', totalBankArray);
            updateWizardData(claimVM);
            setaddInsuredBankButtonClicked(false);
        },
        [bankVM, claimVM, existingInsuredBank, existingInsuredBankArray, insuredBankArray, selectedAccountType, totalBankArray, updateWizardData],
    );

    const editBankCard = useCallback(
        (e, item, index) => {
            e.preventDefault();
            const bankList = _.get(claimVM, 'agentInsuredBankArray_EXT.value');
            bankList.splice((index), 1);
            if (item.insuredBank === true) {
                const insuredBankLst = insuredBankArray.filter((value) => value !== item);
                const totalList = totalBankArray.filter((value) => value !== item);
                setTotalBankArray(totalList);
                setInsuredBankArray(insuredBankLst);
            } else {
                const agentbankList = agentBankArray.filter((value) => value !== item);
                const totalList = totalBankArray.filter((value) => value !== item);
                setTotalBankArray(totalList);
                setAgentBankArray(agentbankList);
            }
            bankVM.value = item;
            _.set(claimVM.value, 'agentInsuredBankArray_EXT', bankList);
            const {
                accountNumber, accountType, branchCode, bankName, accountName, insuredAmount, agentAmount, agentBank, insuredBank, isExistingBankSelected
            } = item;
            setSelectedAccountType(accountType);
            displayBankNames();
            setSelectedBankName(bankName);
            _.set(claimVM, 'accountNumber', accountNumber);
            _.set(claimVM, 'accountName', accountName);
            _.set(claimVM, 'branchCode', branchCode);
            _.set(claimVM, 'bankName', bankName);
            bankVM.accountType = accountType.code;
            _.set(claimVM, 'insuredBank', insuredBank);
            _.set(claimVM, 'agentBank', agentBank);
            _.set(claimVM, 'insuredAmount', insuredAmount);
            _.set(claimVM, 'agentAmount', agentAmount);
            setExistingInsuredBank(isExistingBankSelected === true ? 'Existing' : 'New');
            updateWizardData(claimVM);
            if (insuredBank === true) {
                setaddInsuredBankButtonClicked(true);
                if (isExistingBankSelected === true) {
                    setSelectedInsuredBankAccNo(`${bankName},${accountNumber},${_.get(accountMap, accountType)}`);
                }
            } else {
                setSelectAddAgentButtonClicked(true);
                setSelectedAgentBankAccNo(`${bankName},${accountNumber},${_.get(accountMap, accountType)}`);
            }
        },
        [accountMap, agentBankArray, bankVM.accountType, bankVM.value, claimVM, displayBankNames, insuredBankArray, totalBankArray, updateWizardData]
    );


    const deleteBankCard = useCallback(
        (e, item, index) => {
            e.preventDefault();
            ModalNextProvider.showConfirm({
                title: 'Warning',
                message: 'Are you sure you want to remove this bank?',
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then(async (results) => {
                if (results === 'cancel') {
                    return _.noop();
                }

                const bankList = _.get(claimVM, 'agentInsuredBankArray_EXT.value');
                bankList.splice((index), 1);
                if (item.insuredBank === true) {
                    const insuredBankLst = insuredBankArray.filter((value) => value !== item);
                    const totalList = totalBankArray.filter((value) => value !== item);
                    setTotalBankArray(totalList);
                    setInsuredBankArray(insuredBankLst);
                    const documentList = _.get(claimVM, 'documents.value', []);
                    let bankDocuments = [];
                    if (!_.isEmpty(documentList)) {
                        bankDocuments = documentList.filter((doc) => doc.sasriaFormName_EXT === 'Account or Bank Confirmation');
                    }
                    if (!_.isEmpty(bankDocuments)) {
                        bankDocuments.forEach((bankDoc) => {
                            // const doc = bankDoc;
                            // eslint-disable-next-line no-param-reassign
                            bankDoc.isDocumentTaggedToInsuredBankSTP_EXT = false;
                        });
                    }
                } else {
                    const agentbankList = agentBankArray.filter((value) => value !== item);
                    const totalList = totalBankArray.filter((value) => value !== item);
                    setTotalBankArray(totalList);
                    setAgentBankArray(agentbankList);
                }
                _.set(claimVM.value, 'agentInsuredBankArray_EXT', bankList);
                updateWizardData(claimVM);
                return true;
            }, _.noop);
        },
        [agentBankArray, claimVM, insuredBankArray, totalBankArray, updateWizardData]
    );


    const deletePaymentCard = useCallback(
        (e, item, index) => {
            e.preventDefault();
            ModalNextProvider.showConfirm({
                title: 'Warning',
                message: 'Are you sure you want to remove this payment card?',
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then(async (results) => {
                if (results === 'cancel') {
                    return _.noop();
                }
                const paymentList = _.get(claimVM.value, 'payments_EXT');
                paymentList.splice((index), 1);
                const modifiedPaymentList = paymentList.filter((value) => value !== item);
                setIndividualPaymentArray(modifiedPaymentList);
                _.set(claimVM.value, 'payments_EXT', modifiedPaymentList);
                updateWizardData(claimVM);
                return true;
            }, _.noop);
        },
        [claimVM, updateWizardData]
    );

    const handleAddPayment = useCallback(
        (paymentValue) => {
            // paymentDto = _.get(claimVM, 'paymentDTO');
            const paymentList = _.get(claimVM.value, 'payments_EXT', []);
            if (!_.isEmpty(paymentList) && paymentList.length > 0 && _.isEmpty(individualPaymentArray)) {
                individualPaymentArray.push(...paymentList);
            }
            const { vat_EXT, vat_Excl_EXT, vat_incl_EXT } = paymentValue.value;
            const lineItem = paymentValue.lineItemData_EXT.value;
            const { payeeType_EXT } = claimVM.paymentDTO;
            const { stppaymentType_EXT, payeeRefNo_EXT } = paymentValue;
            const paymentType = !_.isUndefined(stppaymentType_EXT.value) ? stppaymentType_EXT.value.code : 'other';
            const payee = payeeType_EXT.value;
            const paymentRef = payeeRefNo_EXT.value;
            const paymentData = {
                vat_EXT: vat_EXT, vat_Excl_EXT: vat_Excl_EXT, vat_Incl_EXT: vat_incl_EXT, payeeType_EXT: payee, lineItemData_EXT: lineItem, payeeRefNo_EXT: paymentRef, stppaymentType_EXT: paymentType
            };
            individualPaymentArray.push(paymentData);
            _.set(claimVM.value, 'payments_EXT', individualPaymentArray);
            setIndividualPaymentArray(individualPaymentArray);
            setEditPayment(false);
            updateWizardData(claimVM);
        },
        [claimVM, individualPaymentArray, updateWizardData],
    );

    const handleEditPayment = useCallback(
        (paymentValue, item, index) => {
            // paymentDto = _.get(claimVM, 'paymentDTO');
            const { payeeRefNo_EXT } = item;
            const paymentList = _.get(claimVM.value, 'payments_EXT');
            paymentList.splice((index), 1);
            if (!_.isEmpty(paymentList) && paymentList.length > 0 && _.isEmpty(individualPaymentArray)) {
                individualPaymentArray.push(...paymentList);
            }
            //individualPaymentArray.splice(index, 1);
            // const { payments_EXT } = claimVM;
            const modifiedPaymentList = paymentList.filter((value) => value !== item);
            // setIndividualPaymentArray(modifiedPaymentList);
            _.set(claimVM.value, 'payments_EXT', modifiedPaymentList);
            const { vat_EXT, vat_Excl_EXT, vat_incl_EXT } = paymentValue.value;
            const lineItem = paymentValue.lineItemData_EXT.value;
            const { payeeType_EXT } = claimVM.paymentDTO;
            const payee = payeeType_EXT.value;
            const { stppaymentType_EXT } = paymentValue;
            const paymentType = !_.isUndefined(stppaymentType_EXT.value) ? stppaymentType_EXT.value.code : 'other';
            const paymentData = {
                vat_EXT: vat_EXT, vat_Excl_EXT: vat_Excl_EXT, vat_Incl_EXT: vat_incl_EXT, payeeType_EXT: payee, lineItemData_EXT: lineItem, payeeRefNo_EXT, stppaymentType_EXT: paymentType
            };
            individualPaymentArray.push(paymentData);
            _.set(claimVM.value, 'payments_EXT', individualPaymentArray);
            setIndividualPaymentArray(individualPaymentArray);
            setEditPayment(false);
            updateWizardData(claimVM);
        },
        [claimVM, individualPaymentArray, updateWizardData],
    );



    const editPaymentCard = useCallback(
        (e, item, index) => {
            e.preventDefault();
            setEditPayment(true);
            // const paymentList = _.get(claimVM, 'payments_EXT.value');
            // paymentList.splice((index), 1);
            // // const { payments_EXT } = claimVM;
            // const modifiedPaymentList = paymentList.filter((value) => value !== item);
            // setIndividualPaymentArray(modifiedPaymentList);
            // _.set(claimVM.value, 'payments_EXT', modifiedPaymentList);
            ModalNextProvider.showModal(
                <AddPaymentPopup
                    claimVM={claimVM}
                    insuredPayee={insuredBankArray}
                    agentPayee={agentBankArray}
                    paymentData={item}
                    existingDocuments={{}}
                    editPayment
                />
            )
                .then((value) => {
                    handleEditPayment(value, item, index);
                })
                .catch(_.noop);
        },
        [agentBankArray, claimVM, handleEditPayment, insuredBankArray]
    );


    const addAgentBankButtonClickFunc = useCallback(
        () => {
            const accountNumber = _.get(bankVM, 'accountNumber').value;
            const branchCode = _.get(bankVM, 'branchCode').value;
            const bankName = _.get(bankVM, 'bankName').value;
            const publicId = _.get(bankVM, 'publicId').value;
            const accountName = _.get(bankVM, 'accountName').value;
            const insuredBank = false;
            const agentBank = true;
            const agentAmount = _.get(bankVM, 'agentAmount').value;
            if (_.isUndefined(accountNumber) || _.isEmpty(accountNumber)) {
                return handleError(
                    messages.bankAccNumMandatoryTitle,
                    messages.bankAccNumMandatoryMessage
                );
            }

            const regRegex = new RegExp(/^(\d{1,13})?$/);
            if (!_.isUndefined(accountNumber) && !regRegex.test(accountNumber)) {
                return handleError(
                    messages.invalidBankTitle,
                    messages.invalidBankMessage
                );
            }

            if (_.isUndefined(selectedAccountType) || _.isEmpty(selectedAccountType)) {
                return handleError(
                    messages.bankAccTypeMandatoryTitle,
                    messages.bankAccTypeMandatoryMessage
                );
            }

            if (_.isUndefined(branchCode) || _.isEmpty(branchCode)) {
                return handleError(
                    messages.bankCodeNumMandatoryTitle,
                    messages.bankCodeNumMandatoryMessage
                );
            }

            // if (_.isUndefined(agentAmount) || agentAmount === '') {
            //     return handleError(
            //         messages.agentamountFieldMandatoryTitle,
            //         messages.agentamountFieldMandatoryMessage
            //     );
            // }

            // if (isNaN(agentAmount) || parseFloat(agentAmount) <= 0) {
            //     return handleError(
            //         messages.agentamountFieldMandatoryTitle,
            //         messages.agentamountFieldMandatoryMessage
            //     );
            // }


            if (_.isUndefined(bankName) || _.isEmpty(bankName)) {
                return handleError(
                    messages.bankNameMandatoryTitle,
                    messages.bankNameMandatoryMessage
                );
            }
            const bankValue = {
                accountNumber, accountType: selectedAccountType, branchCode, bankName, publicId, accountName, insuredBank, agentBank
            };
            agentBankArray.push(bankValue);
            setAgentBankArray(agentBankArray);
            totalBankArray.push(bankValue);
            setTotalBankArray(totalBankArray);
            _.set(claimVM.value, 'agentInsuredBankArray_EXT', totalBankArray);
            updateWizardData(claimVM);
            setSelectAddAgentButtonClicked(false);
        },
        [agentBankArray, bankVM, claimVM, selectedAccountType, totalBankArray, updateWizardData],
    );

    const addTotalInsuredPayable = useCallback(
        () => {
            const paymentList = _.get(claimVM.value, 'payments_EXT', []);
            let insuredPayable = 0.00;
            if (!_.isUndefined(paymentList) && !_.isEmpty(paymentList)) {
                paymentList.forEach((payment) => {
                    const { payeeType_EXT } = payment;
                    if (payeeType_EXT === 'insured') {
                        const { lineItemData_EXT } = payment;
                        if (!_.isUndefined(lineItemData_EXT) && !_.isEmpty(lineItemData_EXT)) {
                            lineItemData_EXT.forEach((lineItem) => {
                                const { vatInclAmount } = lineItem;
                                insuredPayable += parseFloat(vatInclAmount);
                            });
                        }
                    }
                });
            }
            _.set(claimVM.value, 'totalInsuredPayable_EXT', insuredPayable);
            return insuredPayable.toFixed(2);
        },
        [claimVM.value],
    );

    const addTotalAgentReimbursement = useCallback(
        () => {
            const paymentList = _.get(claimVM.value, 'payments_EXT', []);
            let totalAgentPayable = 0.00;
            if (!_.isUndefined(paymentList) && !_.isEmpty(paymentList)) {
                paymentList.forEach((payment) => {
                    const { payeeType_EXT } = payment;
                    if (payeeType_EXT === 'agent') {
                        const { lineItemData_EXT } = payment;
                        if (!_.isUndefined(lineItemData_EXT) && !_.isEmpty(lineItemData_EXT)) {
                            lineItemData_EXT.forEach((lineItem) => {
                                const { vatInclAmount } = lineItem;
                                totalAgentPayable += parseFloat(vatInclAmount);
                            });
                        }
                    }
                });
            }
            _.set(claimVM.value, 'totalAgentPayable_EXT', totalAgentPayable);
            return totalAgentPayable.toFixed(2);
        },
        [claimVM.value],
    );

    const totalamount = useCallback(
        () => {
            const paymentList = _.get(claimVM.value, 'payments_EXT', []);
            let totalAmtPayable = 0.00;
            if (!_.isUndefined(paymentList) && !_.isEmpty(paymentList)) {
                paymentList.forEach((payment) => {
                    const { lineItemData_EXT } = payment;
                    if (!_.isUndefined(lineItemData_EXT) && !_.isEmpty(lineItemData_EXT)) {
                        lineItemData_EXT.forEach((lineItem) => {
                            const { vatInclAmount } = lineItem;
                            totalAmtPayable += parseFloat(vatInclAmount);
                        });
                    }
                });
            }
            return totalAmtPayable.toFixed(2);
        },
        [claimVM.value],
    );

    const generateBankcardOverrides = useCallback(() => {
        const agentInsuredBankArray = _.get(claimVM.value, 'agentInsuredBankArray_EXT', []);
        const overrides = agentInsuredBankArray.map((elem, index) => {
            return {
                [`individualAccountNumber${index}`]: {
                    value: encryptAccntNum(elem.accountNumber)
                },

                [`individualBankCategory${index}`]: {
                    value: displayBankCategory(elem)
                },

                [`individualAmount${index}`]: {
                    value: displayAmountInCard(elem)
                },

                [`deleteBank${index}`]: {
                    onClick: (e) => {
                        deleteBankCard(e, elem, index);
                    }
                },

                [`editBank${index}`]: {
                    onClick: (e) => {
                        editBankCard(e, elem, index);
                    }
                },

            };
        });
        return Object.assign({}, ...overrides);
    }, [claimVM.value, deleteBankCard, displayAmountInCard, displayBankCategory, editBankCard, encryptAccntNum]);


    const generatPaymentCardOverrides = useCallback(() => {
        const paymentLists = _.get(claimVM.value, 'payments_EXT', []);
        const overrides = paymentLists.map((elem, index) => {
            return {
                [`individualPayeeType${index}`]: {
                    value: displayPayeeType(elem)
                },

                [`individualInclVatPaymentAmount${index}`]: {
                    value: displayIndividualInclVatAmt(elem)
                },

                [`deletePayment${index}`]: {
                    onClick: (e) => {
                        deletePaymentCard(e, elem, index);
                    }
                },

                [`editPayment${index}`]: {
                    onClick: (e) => {
                        editPaymentCard(e, elem, index);
                    }
                },

            };
        });
        return Object.assign({}, ...overrides);
    }, [claimVM.value, deletePaymentCard, displayIndividualInclVatAmt, displayPayeeType, editPaymentCard]);

    const totalFinalEstimate = useCallback(
        () => {
            const classCode = claimVM.policyData_EXT.sasriaClassCode_EXT.value;
            let lossEst = 0.00;
            const prefix = classCode.substring(0, classCode.indexOf(','));
            if (prefix === 'CW') {
                const contractInciArray = claimVM.contractWorksIncidentArray_EXT.value;
                const vehicleInciArray = claimVM.vehicleIncidentArray_EXT.value;
                const propertIncidentArray = claimVM.propertyIncidentArray_EXT.value;
                if (!_.isUndefined(vehicleInciArray) && !_.isEmpty(vehicleInciArray)) {
                    vehicleInciArray.forEach((incident) => {
                        const { lossEstimateInclVATValue } = incident;
                        if (lossEstimateInclVATValue != null && !_.isUndefined(lossEstimateInclVATValue)) {
                            lossEst += lossEstimateInclVATValue;
                        }
                    });
                }
                if (!_.isUndefined(contractInciArray) && !_.isEmpty(contractInciArray)) {
                    contractInciArray.forEach((incident) => {
                        const { lossEstimateInclVATValue } = incident;
                        if (lossEstimateInclVATValue != null && !_.isUndefined(lossEstimateInclVATValue)) {
                            lossEst += lossEstimateInclVATValue;
                        }
                    });
                }
                if (!_.isUndefined(propertIncidentArray) && !_.isEmpty(propertIncidentArray)) {
                    propertIncidentArray.forEach((incident) => {
                        const { lossEstimateInclVATValue } = incident;
                        if (lossEstimateInclVATValue != null && !_.isUndefined(lossEstimateInclVATValue)) {
                            lossEst += lossEstimateInclVATValue;
                        }
                    });
                }
            }
            if (prefix === 'BI') {
                const biIncidentArray = claimVM.businessInterruptionIncidents_EXT.value;
                biIncidentArray.forEach((incident) => {
                    const { lossEstimateInclVATValue } = incident;
                    if (lossEstimateInclVATValue != null && !_.isUndefined(lossEstimateInclVATValue)) {
                        lossEst += lossEstimateInclVATValue;
                    }
                });
            }

            if (prefix === 'M1' || prefix === 'M2' || prefix === 'M3' || prefix === 'M4' || prefix === 'M5'
                || prefix === 'M6' || prefix === 'M7' || prefix === 'M8') {
                const vehicleIncidentArray = claimVM.vehicleIncidentArray_EXT.value;
                vehicleIncidentArray.forEach((incident) => {
                    const { lossEstimateInclVATValue } = incident;
                    if (lossEstimateInclVATValue != null && !_.isUndefined(lossEstimateInclVATValue)) {
                        lossEst += lossEstimateInclVATValue;
                    }
                });
            }

            if (prefix === 'F1' || prefix === 'F2' || prefix === 'F1T' || prefix === 'FE3' || prefix === 'F4' || prefix === 'GIT' || prefix === 'MON') {
                const propertyInci = claimVM.propertyIncident_EXT.value;
                const { lossEstimateInclVATValue } = propertyInci;
                if (lossEstimateInclVATValue != null && !_.isUndefined(lossEstimateInclVATValue)) {
                    lossEst = lossEstimateInclVATValue;
                }
            }
            return lossEst.toFixed(2);
        },
        [claimVM.businessInterruptionIncidents_EXT.value, claimVM.contractWorksIncidentArray_EXT.value, claimVM.policyData_EXT.sasriaClassCode_EXT.value, claimVM.propertyIncidentArray_EXT.value, claimVM.propertyIncident_EXT, claimVM.vehicleIncidentArray_EXT.value],
    );

    const correctIcon = useCallback(
        () => {
            const totalEst = totalFinalEstimate();
            const agentAmt = addTotalAgentReimbursement();
            const insuredAmt = addTotalInsuredPayable();
            if (totalEst !== (parseFloat(agentAmt) + parseFloat(insuredAmt)).toFixed(2)) {
                return 'mi-cancel';
            }
            return 'mi-check-circle';
        },
        [addTotalAgentReimbursement, addTotalInsuredPayable, totalFinalEstimate],
    );

    const deriveCalculationMessage = useCallback(
        () => {
            const totalEst = totalFinalEstimate();
            const agentAmt = addTotalAgentReimbursement();
            const insuredAmt = addTotalInsuredPayable();
            if (totalEst !== (parseFloat(agentAmt) + parseFloat(insuredAmt)).toFixed(2)) {
                return 'Total and Final Loss Estimate NOT Equal';
            }
            return 'Total and Final Loss Estimate Equal';
        },
        [addTotalAgentReimbursement, addTotalInsuredPayable, totalFinalEstimate],
    );


    const validateOnNext = useCallback(() => {
        const totalEst = totalFinalEstimate();
        const agentAmt = addTotalAgentReimbursement();
        const insuredAmt = addTotalInsuredPayable();
        if (_.isEmpty(totalBankArray)) {
            return false;
        }
        if (totalEst !== (parseFloat(agentAmt) + parseFloat(insuredAmt)).toFixed(2)) {
            return false;
        }
        return true;
    }, [addTotalAgentReimbursement, addTotalInsuredPayable, totalBankArray, totalFinalEstimate]);

    useEffect(() => { registerComponentValidation(validateOnNext); }, [
        registerComponentValidation, validateOnNext]);

    const calculataionBlockVisiblity = () => {
        const paymentLists = _.get(claimVM.value, 'payments_EXT', []);
        return !_.isEmpty(paymentLists) && paymentLists.length > 0 && selectAddAgentButtonClicked === false
            && addInsuredBankButtonClicked === false;

    };

    const overrideProps = {
        isReimbursement: {
            value: isReimbursementSelected
        },
        // paymentAmount: {
        //     value: claimVM.sasriaExpressClaimDetails_EXT.paymentAmount.value,
        //     visible: isReimbursementSelected === 'Yes' && paymentIconClicked === true
        // },

        addPaymentButton: {
            disabled: (!_.isUndefined(insuredBankArray) && insuredBankArray.length === 0)
                && (!_.isUndefined(agentBankArray) && agentBankArray.length === 0),
            visible: selectAddAgentButtonClicked === false && addInsuredBankButtonClicked === false
        },


        existingInsuredBank: {
            value: existingInsuredBank
        },

        bankaccountholder: {
            disabled: existingInsuredBank === 'Existing'
        },

        insuredBankDropdown: {
            visible: existingInsuredBank === 'Existing',
            availableValues: insuredBankDropdownList,
            value: selectedInsuredBankAccNo,
        },

        commonPart: {
            visible: selectAddAgentButtonClicked === false && addInsuredBankButtonClicked === false
        },
        proofOfPaymentDiv: {
            visible: addInsuredBankButtonClicked === false && selectAddAgentButtonClicked === false
        },

        totalReimbursement: {
            value: `R${addTotalAgentReimbursement()}`
        },

        totalInsuredPayable: {
            value: `R${addTotalInsuredPayable()}`
        },

        totalamount: {
            value: `R${totalamount()}`
        },

        correctincorrecticon: {
            icon: correctIcon()
        },

        statusMessage: {
            value: deriveCalculationMessage()
        },

        accountType: {
            value: selectedAccountType,
            disabled: existingInsuredBank === 'Existing'
        },

        branchCode: {
            disabled: existingInsuredBank === 'Existing'
        },

        accountNumber: {
            disabled: existingInsuredBank === 'Existing'
        },

        sasriaBankNames: {
            availableValues: bankNamesArray,
            value: selectedBankName,
            disabled: existingInsuredBank === 'Existing'
        },

        finalLossEstimate: {
            value: `R${totalFinalEstimate()}`
        },

        AddButtonLinkForInsured: {
            trigger: addInsuredBankButtonClickFunc
        },

        AddButtonLink: {
            trigger: addAgentBankButtonClickFunc
        },

        bankCardId: {
            visible: !_.isUndefined(claimVM.agentInsuredBankArray_EXT) && !_.isEmpty(claimVM.agentInsuredBankArray_EXT.value)
                && selectAddAgentButtonClicked === false && addInsuredBankButtonClicked === false
        },

        calculationComponent: {
            visible: calculataionBlockVisiblity()
        },
        // calculationComponent: {
        //     visible: false
        // },

        selectAgentBankDiv: {
            visible: selectAddAgentButtonClicked === true && addInsuredBankButtonClicked === false
        },

        addInsuredNewBankComponent: {
            visible: addInsuredBankButtonClicked === true && selectAddAgentButtonClicked === false
        },

        selectAgentBankAccount: {
            visible: agentBankArray.length === 0,
            // disabled: agentBankArray.length > 0
        },
        addInsuredBankAccount: {
            visible: insuredBankArray.length === 0
        },

        documentUpload: {
            path: !_.isUndefined(claimVM) ? claimVM : null,
            updatePath: updateWizardData,
            addInsuredButtonClicked: addInsuredBankButtonClicked
        },
        proofOfPaymentDocumentUpload: {
            path: !_.isUndefined(claimVM) ? claimVM : null,
            updatePath: updateWizardData,
            proofOfPaymentRequired: _.get(claimVM.value, 'reimbursementSelected_EXT') === true,
            addInsuredButtonClicked: addInsuredBankButtonClicked,
            isReimbursementSelected: isReimbursementSelected,
            isPaymentIconClicked: paymentIconClicked,
            setPaymentIconClicked
        },
        agentBankDropdown: {
            availableValues: agentBankDropdownList,
            value: selectedAgentBankAccNo,
        },

        bankSubHeading: {
            visible: selectAddAgentButtonClicked === false
        },

        individualAddPaymentCard: {
            value: _.get(claimVM.value, 'payments_EXT', []),
            visible: selectAddAgentButtonClicked === false && addInsuredBankButtonClicked === false
        },
        ...generateBankcardOverrides(),

        ...generatPaymentCardOverrides()
    };

    const readValue = useCallback(
        (fieldId, path) => {
            return readViewModelValue(
                metadata.pageContent,
                claimVM,
                fieldId,
                path,
                overrideProps
            );
        },
        [claimVM, overrideProps]
    );
    const sasriaExpressClaimViewModel = viewModelService.create(
        _.get(claimVM.value, 'sasriaExpressClaimDetails_EXT') || new SasriaExpressClaim(),
        'cc',
        'edge.capabilities.claim.fnol.dto.SasriaExpressClaimDTO_Ext',
    );
    const [expressClaimVM] = useState(sasriaExpressClaimViewModel);

    const writeValue = useCallback(
        (value, path) => {
            _.set(bankVM, path, value);
            _.set(bankVM, 'accountType.value', selectedAccountType);
            _.set(claimVM.value, 'reimbursementSelected_EXT', (isReimbursementSelected === 'Yes'));
            _.set(expressClaimVM, path, value);
            _.set(claimVM.value, 'sasriaExpressClaimDetails_EXT', expressClaimVM.value);
            // _.set(claimVM.value, 'vehicleIncident_EXT', vehicleIncidentVM.value);
        },
        [bankVM, claimVM.value, expressClaimVM, isReimbursementSelected, selectedAccountType]
    );

    const selectAgentBankAccount = useCallback(
        () => {
            bankVM.accountName = '';
            bankVM.accountNumber = '';
            bankVM.accountType = '';
            bankVM.insuredAmount = '';
            bankVM.branchCode = '';
            bankVM.publicId = null;
            _.set(claimVM, 'accountNumber', '');
            _.set(claimVM, 'accountName', '');
            _.set(claimVM, 'branchCode', '');
            _.set(claimVM, 'agentAmount', '');
            _.set(claimVM, 'insuredAmount', '');
            setSelectedAgentBankAccNo('');
            setSelectAddAgentButtonClicked(true);
        },
        [bankVM.accountName, bankVM.accountNumber, bankVM.accountType, bankVM.branchCode, bankVM.insuredAmount, bankVM.publicId, claimVM],
    );

    const addInsuredBankAccount = useCallback(
        () => {
            bankVM.accountName = '';
            bankVM.accountNumber = '';
            bankVM.accountType = '';
            bankVM.insuredAmount = '';
            bankVM.branchCode = '';
            bankVM.publicId = null;
            _.set(claimVM, 'accountNumber', '');
            _.set(claimVM, 'accountName', '');
            _.set(claimVM, 'branchCode', '');
            _.set(claimVM, 'agentAmount', '');
            _.set(claimVM, 'insuredAmount', '');
            setSelectedBankName('');
            setSelectedAccountType('current_EXT');
            setExistingInsuredBank('New');
            setSelectedInsuredBankAccNo('');
            setaddInsuredBankButtonClicked(true);
            updateWizardData(claimVM);
        },
        [bankVM, claimVM, updateWizardData],
    );


    const addPaymentPopUpOpen = useCallback(() => {
        ModalNextProvider.showModal(
            <AddPaymentPopup
                claimVM={claimVM}
                insuredPayee={insuredBankArray}
                agentPayee={agentBankArray}
                paymentData={{}}
                updateWizardData={updateWizardData}
            />
        )
            .then(handleAddPayment)
            .catch(_.noop);
    }, [agentBankArray, claimVM, handleAddPayment, insuredBankArray, updateWizardData]);

    const onNext = useCallback(() => {
        setIsLoading(true);
        if (insuredBankArray.length > 1) {
            ModalNextProvider.showAlert({
                title: messages.canAddOneInsuredBankAccntTitle,
                message: messages.canAddOneInsuredBankAccntMessage,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return false;
        }

        if (agentBankArray.length > 1) {
            ModalNextProvider.showAlert({
                title: messages.canAddOneAgentBankTitle,
                message: messages.canAddOneAgentBankMessage,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return false;
        }
        const reimbursementSelected = _.get(claimVM.value, 'reimbursementSelected_EXT');
        let paymentDocuments = [];
        let agreementOfLossDocs = [];
        let repairInvoiceDocs = [];
        const softBlockMessages = [];
        const documentList = _.get(claimVM, 'documents.value', []);
        if (!_.isEmpty(documentList)) {
            paymentDocuments = documentList.filter((doc) => doc.sasriaFormName_EXT === 'Proof Of Payment');
            agreementOfLossDocs = documentList.filter((doc) => doc.sasriaFormName_EXT === 'Agreement of Loss');
            repairInvoiceDocs = documentList.filter((doc) => doc.sasriaFormName_EXT === 'Repair Invoice');
        }
        // if (reimbursementSelected === true && _.isEmpty(paymentDocuments)) {
        //     ModalNextProvider.showAlert({
        //         title: messages.paymentDocumentMandatoryTitle,
        //         message: messages.paymentDocumentMandatoryMessage,
        //         status: 'error',
        //         icon: 'mi-error-outline',
        //         confirmButtonText: commonMessages.ok
        //     }).catch(_.noop);
        //     return false;
        // }

        // const paymentAmt = claimVM.sasriaExpressClaimDetails_EXT.paymentAmount.value;
        // const totalEst = totalFinalEstimate();

        // if ((reimbursementSelected === true && !_.isUndefined(paymentAmt) && parseInt(paymentAmt, 10) !== totalEst)
        //     || (reimbursementSelected === true && _.isUndefined(paymentAmt))) {
        //     ModalNextProvider.showAlert({
        //         title: messages.paymentAmountNotMatchingTitle,
        //         message: messages.paymentAmountNotMatchingMessage,
        //         status: 'error',
        //         icon: 'mi-error-outline',
        //         confirmButtonText: commonMessages.ok
        //     }).catch(_.noop);
        //     return false;
        // }


        // if (agentBankArray.length > 0 && reimbursementSelected === false) {
        //     ModalNextProvider.showAlert({
        //         title: messages.reimbursementSelectionValidationTitle,
        //         message: messages.reimbursementSelectionValidationMessage,
        //         status: 'error',
        //         icon: 'mi-error-outline',
        //         confirmButtonText: commonMessages.ok
        //     }).catch(_.noop);
        //     return false;
        // }

        //TODO: Will implement once doc componne is completed in payment popup

        // if (agentBankArray.length > 0 && reimbursementSelected === true && _.isEmpty(repairInvoiceDocs)) {
        //     softBlockMessages.push('Repair Invoice Document needs to be uploaded when paying from Agent Bank Account');
        // }

        // if (insuredBankArray.length > 0 && _.isEmpty(agreementOfLossDocs)) {
        //     softBlockMessages.push('Agreement Of Loss Document needs to be uploaded when paying from Insured bank Account');
        // }

        // if (!_.isEmpty(softBlockMessages)) {
        //     softBlockMessages.push('');
        //     softBlockMessages.push('Select \'No\' to correct.');
        //     softBlockMessages.push('Select \'Yes\' flag claim and continue.');
        // }

        // if (!_.isEmpty(softBlockMessages)) {
        //     return ModalNextProvider.showConfirm({
        //         title: 'Warning',
        //         message: softBlockMessages.join('\n'),
        //         status: 'warning',
        //         icon: 'mi-error-outline',
        //         confirmButtonText: claimsMessages.removeConfirmationYes,
        //         cancelButtonText: claimsMessages.removeConfirmationNo
        //     }).then((results) => {
        //         if (results === 'cancel') {
        //             return false;
        //         }
        //         _.set(claimVM, 'isThisClaimFlagged_EXT.value', true);
        //         return FNOLService.saveBankDetails_EXT(claimVM.value, authHeader)
        //             .then(() => {
        //                 return claimVM;
        //             })
        //             .catch((err) => {
        //                 return history.push('/claims');
        //             })
        //             .finally(() => {
        //                 setIsLoading(false);
        //             });
        //     });
        // }

        return FNOLService.saveBankDetails_EXT(claimVM.value, authHeader)
            .then(() => {
                return claimVM;
            })
            .catch((err) => {
                return history.push('/claims');
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [FNOLService, agentBankArray.length, authHeader, claimVM, history, insuredBankArray.length]);

    const resolvers = {

        resolveCallbackMap: {
            selectAgentBankAccount: selectAgentBankAccount,
            addInsuredBankAccount: addInsuredBankAccount,
            handleReimbursement: handleReimbursement,
            addAgentBankButtonClickFunc: addAgentBankButtonClickFunc,
            populateBankNamesFromCC: populateBankNamesFromCC,
            handleAccountType: handleAccountType,
            selectExistingAgentBank: selectExistingAgentBank,
            handleExistingInsuredBank: handleExistingInsuredBank,
            selectExistingInsuredBank: selectExistingInsuredBank,
            addPaymentPopUpOpen: addPaymentPopUpOpen
        },

        resolveComponentMap: {
            CustomizedUploadComponent: CustomizedUploadComponent
        },

        resolveClassNameMap: styles

    };
    return (
        <WizardPage
            disableNext={!isComponentValid}
            onNext={onNext}
            template={WizardPageTemplate}

        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                resolveValue={readValue}
                onValueChange={writeValue}
            // onValidationChange={onValidate}
            />
        </WizardPage>
    );
}
SasriaAddBank.propTypes = wizardProps;
SasriaAddBank.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};

export default withRouter(withAuthenticationContext(SasriaAddBank));
